import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {EnvironmentService} from '../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusinessDashboard} from '../../models/my-business-dashboard';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {EventBusService} from '../../services/event-bus.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {GeneralModalComponent} from '../general-modal/general-modal.component';
import {NgInitDirective} from '../../services/ng-init.directive';

declare var ApexCharts: any;
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, GeneralModalComponent, NgInitDirective],
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  myBusinessDashboard?: MyBusinessDashboard;
  monthlyLimitPercentage: any;
  targetSalesPercentage: any;
  targetSalesRemaining: any;
  monthlyLimitColor: any;
  incentiveLimitColor: any;
  loading: any;

  @ViewChild('dailySales') dailySales: ElementRef;
  @ViewChild('generalModal') generalModal: ElementRef;

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  adsHtmlContent: any;

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusinessDashboard.myBusiness.subAccountType, this.myBusinessDashboard.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  constructor(private loader: GlobalLoaderService,
              private env: EnvironmentService,
              private eventBus: EventBusService,
              private translate: TranslateService,
              private api: ApiAgentService) {
  }

  decodeFromBase64(base64: string): string {
    const binaryString = atob(base64);
    const binaryArray = new Uint8Array(Array.from(binaryString, char => char.charCodeAt(0)));
    return new TextDecoder().decode(binaryArray);
  }


  async ngOnInit() {
    this.loading = true;
    setTimeout(async () => {
      await this.loader.loadExternalStyles('/assets/css/dashboard/dash_1.css');
      await this.loader.loadExternalStyles('/plugins/apex/apexcharts.css');
      await this.loader.loadExternalScript('/apexcharts.js');

      this.myBusinessDashboard = await this.api.getMyBusinessDashboard();

      this.eventBus.emitRefreshMyBusiness();

      this.api.getMyAdsNote().then((data: { html: any; }) => {
        // base64 decode data.html
        if (data.html) {
          // this.adsHtmlContent = decodeURIComponent(atob(data.html));
          this.adsHtmlContent = this.decodeFromBase64(data.html);
          console.log('adsHtmlContent', this.adsHtmlContent);
          $('#adsNoteModal').modal('show');
        }
      });
      this.loading = false;
      this.checkPermission();

      // calculate the monthly limit
      try {
        if (isNotNullOrUndefined(this.myBusinessDashboard.monthlyLimit) && isNotNullOrUndefined(this.myBusinessDashboard.currentLimit)) {
          this.monthlyLimitPercentage = this.myBusinessDashboard.currentLimit / this.myBusinessDashboard.monthlyLimit * 100;
          if (this.monthlyLimitPercentage >= 0 && this.monthlyLimitPercentage < 50) {
            this.monthlyLimitColor = 'bg-primary';
          } else if (this.monthlyLimitPercentage >= 50 && this.monthlyLimitPercentage < 70) {
            this.monthlyLimitColor = 'bg-success';
          } else if (this.monthlyLimitPercentage >= 70 && this.monthlyLimitPercentage < 90) {
            this.monthlyLimitColor = 'bg-warning';
          } else if (this.monthlyLimitPercentage >= 90) {
            this.monthlyLimitColor = 'bg-danger';
          }
        }

        // coloring incentive color.
        if (isNotNullOrUndefined(this.myBusinessDashboard.totalSales) && isNotNullOrUndefined(this.myBusinessDashboard.totalSales.targetThisMonth) && isNotNullOrUndefined(this.myBusinessDashboard.totalSales.thisMonth)) {
          if (this.myBusinessDashboard.totalSales.targetThisMonth > -1) {
            this.targetSalesPercentage = this.myBusinessDashboard.totalSales.thisMonth / this.myBusinessDashboard.totalSales.targetThisMonth * 100;
            this.targetSalesRemaining = this.myBusinessDashboard.totalSales.targetThisMonth - this.myBusinessDashboard.totalSales.thisMonth;
            if (this.targetSalesRemaining < 0) {
              this.targetSalesRemaining = 0;
            }
            if (this.targetSalesPercentage >= 0 && this.targetSalesPercentage < 50) {
              this.incentiveLimitColor = 'bg-danger';
            } else if (this.targetSalesPercentage >= 50 && this.targetSalesPercentage < 70) {
              this.incentiveLimitColor = 'bg-danger';
            } else if (this.targetSalesPercentage >= 70 && this.targetSalesPercentage < 90) {
              this.incentiveLimitColor = 'bg-danger';
            } else if (this.targetSalesPercentage >= 90 && this.targetSalesPercentage < 100) {
              this.incentiveLimitColor = 'bg-danger';
            } else if (this.targetSalesPercentage >= 100) {
              this.incentiveLimitColor = 'bg-success';
            }
          }
        }
      } catch (ex) {
        console.log(ex);
        this.monthlyLimitPercentage = null;
        this.monthlyLimitColor = 'bg-dark';
      }
      // this.setupTopCustomerChart();
      setTimeout(() => {
        this.api.getMyBusinessDashboardTopTenClients().then((data: { topTenClients: any; }) => {
          console.log('topTenClients', data.topTenClients);
          this.myBusinessDashboard.topTenClients = data.topTenClients;
        });

        this.api.getMyBusinessDashboardTopTenProducts().then((data: { topTenProducts: any; }) => {
          console.log('topTenProducts', data.topTenProducts);
          this.myBusinessDashboard.topTenProducts = data.topTenProducts;
        });
      }, 100);
    }, 1000);
  }

  async setupTopCustomerChart() {

    try {
      let data = [];
      let customer = [];

      let sar = await this.translate.get('SAR').toPromise();

      if (this.myBusinessDashboard.topTenClients) {
        for (let client of this.myBusinessDashboard.topTenClients) {
          data.push(client.amount + ' ' + sar);
          customer.push(client.name);
        }
      }
      const options = {
        series: [{
          name: await this.translate.get('Purchases').toPromise(),
          data: data.reverse()
        }],
        annotations: {
          points: [{
            seriesIndex: 0,
            label: {
              borderColor: '#775DD0',
              offsetY: 0,
              style: {
                color: '#fff',
                background: 'linear-gradient(88deg, #3431C8 -43.36%, #AA3DFF 428.43%)',
              },
              // text: 'Bananas are good',
            }
          }]
        },
        chart: {
          toolbar: {
            show: false,
          },
          height: 250,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 0
        },

        grid: {
          row: {
            colors: ['#fff', '#f2f2f2']
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: customer.reverse(),
          tickPlacement: 'on'
        },
        yaxis: {
          show: false,
          opposite: true
        },
        fill: {
          type: 'fill',
          colors: ['#3431C8'],
          // gradient: {
          //   shade: 'light',
          //   type: 'horizontal',
          //   shadeIntensity: 0.25,
          //   gradientToColors: undefined,
          //   inverseColors: true,
          //   opacityFrom: 0.85,
          //   opacityTo: 0.85,
          //   stops: [50, 0, 100]
          // },
        }
      };
      let d_2C_1 = new ApexCharts(document.querySelector('#daily-sales'), options);
      console.log('chart', d_2C_1);
      d_2C_1.render();
    } catch (e) {
      console.error('Chart Error', e);
    }
  }


  async setupTopProductsChart() {

    try {
      let data = [];
      let products = [];

      if (this.myBusinessDashboard.topTenProducts) {
        for (let Products of this.myBusinessDashboard.topTenProducts) {
          data.push(Products.qtySold);
          products.push(Products.title);
        }
      }
      const options = {
        series: [{
          name: await this.translate.get('Sold Qty').toPromise(),
          data: data
        }],
        annotations: {
          points: [{
            seriesIndex: 0,
            label: {
              borderColor: '#775DD0',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#775DD0',
              },
              // text: 'Bananas are good',
            }
          }]
        },
        chart: {
          toolbar: {
            show: false,
          },
          height: 250,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            // endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 0
        },

        grid: {
          row: {
            colors: ['#fff', '#f2f2f2']
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: products,
          tickPlacement: 'on'
        },
        yaxis: {
          opposite: true
        },
        fill: {
          type: 'fill',
          colors: ['#3431C8']
        }
      };
      const d_2C_1 = new ApexCharts(document.querySelector('#products-sales'), options);
      console.log('chart', d_2C_1);
      d_2C_1.render();
    } catch (e) {
      console.error('error chart', e);
    }
  }
}
